var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateUUID } from "flavr-common";
import { MessageService } from "../../ui/services/message.service";
class FileService {
    constructor() {
        this.files = new Map();
        this.filesByUrl = new Map();
    }
    generateUUIDFileId() {
        let id = generateUUID();
        while (this.files.has(id)) {
            id = generateUUID();
        }
        return id;
    }
    add(file) {
        if (this.files.has(file.fileId))
            return false;
        this.files.set(file.fileId, file);
        return true;
    }
    remove(file) {
        this.files.delete(file.fileId);
        const url = file.getUrl();
        if (url) {
            this.filesByUrl.delete(url);
        }
    }
    get(fileId) {
        return this.files.get(fileId);
    }
    getByUrl(url) {
        return this.filesByUrl.get(url);
    }
    registerUrl(fileId, url) {
        const file = this.files.get(fileId);
        if (!file)
            return;
        this.filesByUrl.set(url, file);
    }
    getDataByUrl(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const file = this.filesByUrl.get(url);
            if (!file)
                return undefined;
            return yield file.getData();
        });
    }
    copyDataToClipboard(file) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!("clipboard" in navigator))
                return false;
            const clipboard = navigator.clipboard;
            try {
                const fileData = yield file.getData();
                if (!fileData)
                    return false;
                if (typeof fileData === "string") {
                    yield clipboard.writeText(fileData);
                    return true;
                }
                if (fileData instanceof Blob) {
                    const item = [new ClipboardItem({ [fileData.type]: fileData })];
                    yield clipboard.write(item);
                    return true;
                }
            }
            catch (error) {
                console.error("[bus]", error);
                MessageService.showMessage("error", `Error copying to clipboard: ${JSON.stringify(error)}`);
            }
            return false;
        });
    }
    copyDataToClipboardByUrl(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const file = this.getByUrl(url);
            if (!file)
                return false;
            return yield this.copyDataToClipboard(file);
        });
    }
    imageToBlob(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const img = new Image();
            const c = document.createElement("canvas");
            const ctx = c.getContext("2d");
            if (!ctx)
                return undefined;
            img.crossOrigin = "";
            img.src = url;
            return yield new Promise((resolve) => {
                img.onload = function () {
                    c.width = img.width;
                    c.height = img.height;
                    ctx.drawImage(img, 0, 0);
                    c.toBlob((blob) => {
                        if (!blob) {
                            resolve(undefined);
                            return;
                        }
                        resolve(blob);
                    }, "image/png", 0.75);
                };
            });
        });
    }
}
export const fileService = new FileService();
